import { createClient } from "@contentgrowth/content-auth/client";
import { apiConfig } from '@/config/api';

// Initialize the content-auth client
export const authClient = createClient(apiConfig.baseUrl + "/api/auth");
